import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';
import { Navigator } from '../../menu/navigator';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header-tabs',
  templateUrl: './header-tabs.component.html',
  styleUrls: ['./header-tabs.component.scss'],
})
export class HeaderTabsComponent implements OnInit {

  public tabButtons: any[] = [];
  public activeTab: string;
  private routerSubscription: Subscription;

  constructor(
    private config: ConfigService,
    private navigator: Navigator,
    private router: Router
  ) {
    this.tabButtons = this.config?.getConfig().PRODUCTVERTICALS;
  }

  ngOnInit() {
    this.updateActiveTabBasedOnRoute(this.router.url);

    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateActiveTabBasedOnRoute(event.urlAfterRedirects);
      }
    });
  }

  public loadTab(tab: any): any {
    const code: string = tab?.product_vertical_code;
    switch (code) {
      case 'CASINO':
        this.navigator.toCasino(true);
        break;
      case 'SPORTS':
        this.navigator.toSports(true);
        break;
      case 'LIVE_DEALER':
        this.navigator.toLiveDealer(true);
        break;
      default:
        // this.navigator.toHome(true);
        break;
    }

  }

  private updateActiveTabBasedOnRoute(route: string): void {
    if (route.includes('casino')) {
      this.activeTab = 'CASINO';
    } else if (route.includes('sports')) {
      this.activeTab = 'SPORTS';
    } else if (route.includes('live-dealer')) {
      this.activeTab = 'LIVE_DEALER';
    } else {
      this.activeTab = ''; // Default or home tab
    }
  }

}

// "name" : "PRODUCTVERTICALS",
// "value" : [ {
//   "display_name" : "Casino",
//   "product_vertical_code" : "CASINO",
//   "lobby_name" : "CASINO",
//   "icon_name" : "casino3.svg"
// }, {
//   "display_name" : "Sports",
//   "product_vertical_code" : "SPORTS",
//   "lobby_name" : "SPORTS",
//   "icon_name" : "sports3.svg"
// }, {
//   "display_name" : "Live Dealer",
//   "product_vertical_code" : "LIVE_DEALER",
//   "lobby_name" : "LIVE_DEALER",
//   "icon_name" : "dealer3.svg"
// } ]